import { FC } from 'react';
import { UnallocatedTaskByWasteItem } from '../../../../../../../types/carAllocation';
import styles from './styles.module.css';
import classNames from 'classnames';
import CheckBox from '../../../../../../../components/common/CheckBox';
import { format } from 'date-fns';
import CalcStatus from '../../../../../../../components/common/CalcStatus';
import { formatTime } from '../../../../../../../services/formatTime';
import { getWeekDaysText } from '../../../../../../../services/weekDays';

type Props = {
  selected: UnallocatedTaskByWasteItem | null;
  list: UnallocatedTaskByWasteItem[];
  onSelect: (selected: UnallocatedTaskByWasteItem | null) => void;
};
const formatDateLabel = (date: Date) => format(date, 'yyyy/M/d');
const Tables: FC<Props> = ({ selected, list, onSelect }) => {
  return (
    <div className={styles.tableContainer}>
      <table className={classNames(styles.table, 'rounded-corners')}>
        <TableHead />
        <tbody>
          {list.map((item, i) => {
            const isSelected = Boolean(
              item.contractId === selected?.contractId &&
                item.wasteItems &&
                selected?.wasteItems &&
                item.wasteItems.id === selected?.wasteItems.id
            );
            return (
              <tr
                key={i}
                className={classNames(
                  styles.dataRow,
                  selected && !isSelected && styles.notSelected
                )}
              >
                <td className={classNames(styles.dataCell, styles.checkCell)}>
                  <CheckBox
                    value={item.contractId}
                    checked={isSelected}
                    isLabelNoneStyle={true}
                    onChange={() => {
                      if (selected) {
                        onSelect(null);
                        return;
                      }
                      onSelect(item);
                    }}
                  ></CheckBox>
                </td>
                <td className={styles.dataCell}>
                  <CalcStatus
                    calcStatus={item.calcStatus}
                    calcValidDate={item.calcValidDate}
                    collectionConstraintTypeId={
                      item.collectionConstraintType.id
                    }
                  />
                </td>
                <td className={classNames(styles.dataCell, styles.contractNo)}>
                  {item.contractNo}
                </td>
                <td
                  className={classNames(styles.dataCell, styles.collectionDate)}
                >
                  <div>
                    {formatDateLabel(new Date(item.workStartDate))}
                    {item.workEndDate && (
                      <>
                        -<wbr />
                        {formatDateLabel(new Date(item.workEndDate))}
                      </>
                    )}
                  </div>
                  {item.collectionConstraintWeekDays && (
                    <div className={styles.dayLabel}>
                      {getWeekDaysText(item.collectionConstraintWeekDays)}
                    </div>
                  )}
                  <div className={styles.timeLabel}>
                    {item.specificTimeStartAt &&
                      item.specificTimeEndAt &&
                      `${formatTime(item.specificTimeStartAt)}-${formatTime(
                        item.specificTimeEndAt
                      )}`}
                  </div>
                </td>
                <td className={classNames(styles.dataCell, styles.companyName)}>
                  <div className={styles.companyNameBox}>
                    {item.supplierCompany?.name}
                  </div>
                </td>
                <td className={classNames(styles.dataCell, styles.companyName)}>
                  <div className={styles.companyNameBox}>
                    {item.contractorCompany?.name}
                  </div>
                </td>
                <td className={classNames(styles.dataCell, styles.companyName)}>
                  <div className={styles.companyNameBox}>
                    {item.wastePointCompany?.name}
                  </div>
                </td>
                <td
                  className={classNames(styles.dataCell, styles.workCategory)}
                >
                  {item.goesStraight ? '直行' : '積保'}
                </td>
                <td className={classNames(styles.dataCell, styles.wasteItem)}>
                  {item.wasteItems &&
                    `${item.wasteItems.id}.${item.wasteItems.name}`}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
const TableHead = () => {
  return (
    <thead>
      <tr className={styles.headRow}>
        <th className={classNames(styles.headCell, styles.checkCell)}></th>
        <th className={styles.headCell}>計算</th>
        <th className={classNames(styles.headCell, styles.contractNo)}>
          契約No
        </th>
        <th className={classNames(styles.headCell, styles.collectionDate)}>
          回収日
        </th>
        <th className={classNames(styles.headCell, styles.companyName)}>
          排出事業者
        </th>
        <th className={classNames(styles.headCell, styles.companyName)}>
          委託先
        </th>
        <th className={classNames(styles.headCell, styles.companyName)}>
          排出事業場
        </th>
        <th className={classNames(styles.headCell, styles.workCategory)}>
          作業
        </th>
        <th className={classNames(styles.headCell, styles.wasteItem)}>
          廃棄品目
        </th>
      </tr>
    </thead>
  );
};

export default Tables;
